import _ from 'lodash'
///
const setupFormatResponse = services => {
  // response interceptor
  const handleSuccessResponse = response => {
    // Do something with response data
    if (response?.data) {
      return response.data
    }
    return response
  }
  const handleErrorResponse = error => {
    if (!error.response) {
      return Promise.reject({
        errors: {
          general: ['Network error'],
        },
        error_code: 0,
      })
    }
    if (error.response?.data) {
      // put errors field in case there is none
      return Promise.reject({
        errors: {},
        ...error.response.data,
        error_code: error.response?.status || 500,
      })
    }
    if (!error.response?.data) {
      return Promise.reject({
        errors: {
          general: ['Something went wrong'],
        },
        error_code: error.response?.status || 500,
      })
    }
    // Do something with response data
    return Promise.reject(error)
  }

  // set interceptors
  _.map(services, service => {
    service.interceptors.response.use(handleSuccessResponse, handleErrorResponse)
  })
}

export default setupFormatResponse
